(function () {
  if (window.__brewGuidesSectionInit) return;
  window.__brewGuidesSectionInit = true;

  function isBlank(value) {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    return false;
  }

  function normalizeValue(value) {
    if (isBlank(value)) return '';
    return String(value).trim();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseMaybeJson(value) {
    if (isBlank(value)) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return value;

    var parsed = value;
    for (var i = 0; i < 4; i += 1) {
      if (typeof parsed !== 'string') return parsed;

      var trimmed = parsed.trim();
      if (!trimmed) return null;

      var first = trimmed.charAt(0);
      var last = trimmed.charAt(trimmed.length - 1);
      var looksLikeJson = first === '{' || first === '[';
      var looksLikeQuotedJson = first === '"' && last === '"';

      if (!looksLikeJson && !looksLikeQuotedJson) return trimmed;

      try {
        parsed = JSON.parse(trimmed);
      } catch (error) {
        return trimmed;
      }
    }

    return parsed;
  }

  function readSectionJson(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return null;
    return parseMaybeJson(node.textContent);
  }

  function pickField(candidates, fieldName) {
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue;
      if (!isBlank(candidate[fieldName])) return candidate[fieldName];
    }
    return null;
  }

  function resolveCandidates(section) {
    var metafieldRaw = readSectionJson(section, '[data-brew-kirby-metafield]');
    var contentRaw = readSectionJson(section, '[data-brew-kirby-content]');
    var valueRaw = readSectionJson(section, '[data-brew-kirby-content-value]');

    var metafield = parseMaybeJson(metafieldRaw);
    var content = parseMaybeJson(contentRaw);
    var value = parseMaybeJson(valueRaw);

    var metafieldValue = null;
    if (metafield && typeof metafield === 'object' && !Array.isArray(metafield) && metafield.value !== undefined) {
      metafieldValue = parseMaybeJson(metafield.value);
    }

    var nested = null;
    var nestedCandidates = [metafield, metafieldValue, value, content];
    for (var i = 0; i < nestedCandidates.length; i += 1) {
      var candidate = nestedCandidates[i];
      if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue;
      if (candidate.content === undefined) continue;
      nested = parseMaybeJson(candidate.content);
      if (nested) break;
    }

    return {
      product: [nested, metafieldValue, value, metafield, content]
    };
  }

  function firstArrayItem(value) {
    if (Array.isArray(value) && value.length) return value[0];
    return value;
  }

  function normalizeAction(actionValue) {
    if (Array.isArray(actionValue)) {
      return actionValue
        .map(function (entry) {
          return normalizeValue(entry);
        })
        .filter(Boolean)
        .join(', ');
    }
    return normalizeValue(actionValue);
  }

  function resolveVideoId(videoField) {
    var firstVideo = firstArrayItem(videoField);
    if (!firstVideo) return '';
    if (typeof firstVideo === 'string') return normalizeValue(firstVideo);
    if (typeof firstVideo === 'object') {
      return normalizeValue(firstVideo.id || firstVideo.video_id || firstVideo.wistia_id);
    }
    return '';
  }

  function buildSelectorLabel(guide) {
    var fields = (guide && guide.fields) || {};
    var guideType = normalizeValue(fields.guide_type) || 'Guide';
    var language = normalizeValue(fields.language).toLowerCase();
    var languageLabel = '';

    if (language === 'en') languageLabel = 'English';
    else if (language === 'es') languageLabel = 'Espanol';
    else if (language) languageLabel = language.toUpperCase();

    return languageLabel ? guideType + ' - ' + languageLabel : guideType;
  }

  function buildFilterRecipeHtml(pours) {
    if (!Array.isArray(pours) || !pours.length) return '';

    return pours
      .map(function (step) {
        var time = normalizeValue(step && step.time);
        var action = normalizeAction(step && step.action);
        var weight = normalizeValue(step && step.weight);
        var hasDrain = action.toLowerCase().indexOf('drain') > -1;

        if (hasDrain) {
          return escapeHtml(action + (time ? ' ' + time : '')) + '<br>';
        }

        var line = '';
        if (time) {
          line += escapeHtml(time) + '<span class="desktop-only"> - </span>';
        }

        if (action) {
          line += '<span class="brew-step-action">' + escapeHtml(action);
          if (weight) line += ' - ' + escapeHtml(weight) + 'g';
          line += '</span>';
        }

        return line + '<br class="desktop-only">';
      })
      .join('');
  }

  function buildGuideTopHtml(guide, labels, aidenLink) {
    var fields = (guide && guide.fields) || {};
    var guideType = normalizeValue(guide && guide.type);

    if (guideType === 'brew_guide_filter') {
      var equipment = normalizeValue(fields.equipment);
      var filterName = normalizeValue(firstArrayItem(fields.filter));
      var equipmentLine = [equipment, filterName].filter(Boolean).join(' & ');
      var coffeeWeight = normalizeValue(fields.coffee_weight);
      var waterWeight = normalizeValue(fields.water_weight);
      var waterTemp = normalizeValue(fields.water_temp);
      var grindSize = normalizeValue(fields.grind_size);
      var recipeHtml = buildFilterRecipeHtml(fields.pours);

      var html = '';
      html += '<div>';
      html += '<p><strong>' + escapeHtml(labels.overviewLabel) + '</strong></p>';
      if (equipmentLine) html += '<p>' + escapeHtml(equipmentLine) + '</p>';
      if (coffeeWeight) html += '<p>Coffee: ' + escapeHtml(coffeeWeight) + 'g</p>';
      if (waterWeight || waterTemp) {
        html += '<p>Water: ' + escapeHtml(waterWeight) + 'g @ ' + escapeHtml(waterTemp) + '&deg;F</p>';
      }
      html += '<br>';
      html += '<p><strong>' + escapeHtml(labels.grindLabel) + '</strong><br>' + escapeHtml(grindSize) + '&micro;m</p>';
      if (grindSize) {
        html += '<p><a href="https://onyxcoffeelab.com/pages/grind-size-calculator?um=' + encodeURIComponent(grindSize) + '" class="grind-calc" target="_blank" rel="noopener">' + escapeHtml(labels.grindCalcLabel) + '</a></p>';
      }
      html += '</div>';

      html += '<div>';
      html += '<p><strong>' + escapeHtml(labels.recipeLabel) + '</strong></p>';
      html += '<p>' + recipeHtml + '</p>';
      if (aidenLink) {
        html += '<br><p><a href="' + escapeHtml(aidenLink) + '" target="_blank" rel="noopener" class="grind-calc">' + escapeHtml(labels.aidenProfileLabel) + '</a></p>';
      }
      html += '</div>';

      return html;
    }

    if (guideType === 'brew_guide_espresso') {
      var espressoHtml = '';
      espressoHtml += '<div>';
      espressoHtml += '<p><strong>' + escapeHtml(labels.overviewLabel) + '</strong></p>';
      if (fields.equipment) espressoHtml += '<p>' + escapeHtml(fields.equipment) + '</p>';
      if (!isBlank(fields.coffee_weight)) espressoHtml += '<p>Coffee: ' + escapeHtml(fields.coffee_weight) + 'g</p>';
      if (!isBlank(fields.yield)) espressoHtml += '<p>Yield: ' + escapeHtml(fields.yield) + 'g</p>';
      espressoHtml += '</div>';

      espressoHtml += '<div>';
      espressoHtml += '<p><strong>' + escapeHtml(labels.recipeLabel) + '</strong></p>';
      espressoHtml += '<p>' + escapeHtml(labels.espressoLinePressureLabel) + '</p>';
      if (!isBlank(fields.time)) espressoHtml += '<p>9 Bar: ' + escapeHtml(fields.time) + 's</p>';
      espressoHtml += '</div>';

      return espressoHtml;
    }

    if (guideType === 'brew_guide_instant') {
      return [
        '<div>',
        '<p><strong>HOT</strong></p>',
        '<p>Coffee: 1x Packet</p>',
        '<p>Water: 8oz @ 160&deg;F</p>',
        '<p>Stir!</p>',
        '<br>',
        '<p><strong>COLD</strong></p>',
        '<p>Coffee: 1x Packet</p>',
        '<p>Water: 8oz @ Room Temp</p>',
        '<p>Add ice and stir!</p>',
        '</div>'
      ].join('');
    }

    var fallbackHtml = '';
    fallbackHtml += '<div>';
    fallbackHtml += '<p><strong>' + escapeHtml(labels.overviewLabel) + '</strong></p>';
    if (fields.equipment) fallbackHtml += '<p>' + escapeHtml(fields.equipment) + '</p>';
    if (fields.notes) fallbackHtml += '<p>' + escapeHtml(fields.notes) + '</p>';
    fallbackHtml += '</div>';

    return fallbackHtml;
  }

  function shouldHideBrewTimer(guide) {
    var fields = (guide && guide.fields) || {};
    var guideTypeLabel = normalizeValue(fields.guide_type).toLowerCase();

    if (!guideTypeLabel) return false;
    if (guideTypeLabel.indexOf('espresso') > -1) return true;
    if (guideTypeLabel.indexOf('cold brew') > -1) return true;
    if (guideTypeLabel === 'fellow aiden') return true;
    if (guideTypeLabel === 'auto drip machine') return true;
    return false;
  }

  function parseTimeToSeconds(timeString) {
    var normalized = normalizeValue(timeString);
    if (!normalized) return 0;

    var parts = normalized.split(':');
    var minutes = Number(parts[0] || 0);
    var seconds = Number(parts[1] || 0);
    if (!Number.isFinite(minutes)) minutes = 0;
    if (!Number.isFinite(seconds)) seconds = 0;
    return minutes * 60 + seconds;
  }

  function getFlowRateForAction(actionText) {
    var action = normalizeValue(actionText).toLowerCase();
    if (action === 'bloom') return 5;
    if (action === 'heavy spiral pour') return 13;
    if (action === 'spiral pour') return 10;
    if (action === 'center pour') return 15;
    return 10;
  }

  function buildTimerHtml(guide) {
    var fields = (guide && guide.fields) || {};
    var pours = Array.isArray(fields.pours) ? fields.pours : [];
    if (!pours.length) return '';

    var equipment = normalizeValue(fields.equipment);
    var beans = Number(normalizeValue(fields.coffee_weight) || 0);
    var water = Number(normalizeValue(fields.water_weight) || 0);
    var temp = normalizeValue(fields.water_temp);
    var grind = normalizeValue(fields.grind_size);
    var maxTime = normalizeValue(pours[pours.length - 1] && pours[pours.length - 1].time) || '0:00';
    var duration = parseTimeToSeconds(maxTime);

    var maxWeight = 0;
    for (var i = 0; i < pours.length; i += 1) {
      var stepWeight = Number(normalizeValue(pours[i] && pours[i].weight) || 0);
      if (Number.isFinite(stepWeight) && stepWeight > maxWeight) maxWeight = stepWeight;
    }

    var ratio = beans > 0 ? water / beans : 0;
    var ratioRounded = Math.round(ratio * 100) / 100;

    var firstStep = pours[0] || {};
    var firstAction = normalizeAction(firstStep.action);
    var firstTime = normalizeValue(firstStep.time) || '0:00';
    var firstWeight = normalizeValue(firstStep.weight) || '0';

    var stepsHtml = pours
      .map(function (step, index) {
        var stepTime = normalizeValue(step && step.time) || '0:00';
        var totalSeconds = parseTimeToSeconds(stepTime);
        var actionText = normalizeAction(step && step.action) || 'Step ' + (index + 1);
        var stepWeight = normalizeValue(step && step.weight);
        var flowRate = getFlowRateForAction(actionText);
        var summary = actionText;
        if (stepWeight) summary += ' to ' + stepWeight + 'g';

        return (
          '<li class=\"kapra step\" data-time=\"' +
          escapeHtml(totalSeconds) +
          '\" data-weight=\"' +
          escapeHtml(stepWeight || 0) +
          '\" data-action=\"' +
          escapeHtml(actionText) +
          '\" data-flow-rate=\"' +
          escapeHtml(flowRate) +
          '\">' +
          '<span>' +
          escapeHtml(stepTime) +
          '</span>' +
          '<span>' +
          escapeHtml(summary) +
          '</span>' +
          '</li>'
        );
      })
      .join('');

    return [
      '<div class=\"container\">',
      '<div class=\"brew-timer\" data-duration=\"' + escapeHtml(duration) + '\">',
      '<div class=\"details kapra\">',
      '<div class=\"detail\">Method: ' + escapeHtml(equipment) + '</div>',
      '<div class=\"detail\">Coffee: ' + escapeHtml(beans || 0) + 'g</div>',
      '<div class=\"detail\">Ratio: 1:' + escapeHtml(ratioRounded) + '</div>',
      '<div class=\"detail\">Water: ' + escapeHtml(water || 0) + 'g @ ' + escapeHtml(temp) + '&deg;F</div>',
      '<div class=\"detail\">Grind: ' + escapeHtml(grind) + 'um</div>',
      '</div>',
      '<div class=\"timer\">',
      '<div class=\"start\"><h3 class=\"kapra\">Ready to brew?</h3><button class=\"start\">Start the timer</button></div>',
      '<div class=\"running hidden\">',
      '<button class=\"pause\">Pause timer</button>',
      '<div class=\"info\">',
      '<h2 class=\"kapra step\">' + escapeHtml(firstAction) + '</h2>',
      '<h3 class=\"kapra step-detail\"><small class=\"max-time\">' + escapeHtml(maxTime) + '</small><span class=\"time\">' + escapeHtml(firstTime) + '</span> / <span class=\"weight\">' + escapeHtml(firstWeight) + '</span>g <small class=\"max-weight\">' + escapeHtml(maxWeight) + 'g</small></h3>',
      '</div>',
      '<button class=\"restart\">Start over</button>',
      '</div>',
      '<div class=\"timeline\" style=\"--steps: ' + escapeHtml(pours.length) + '\">',
      '<div class=\"events\"><ul>',
      stepsHtml,
      '</ul><span class=\"filling-line\" aria-hidden=\"true\"></span><span class=\"pre-line\" aria-hidden=\"true\"></span><span class=\"post-line\" aria-hidden=\"true\"></span></div>',
      '</div>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function buildGuideHtml(guide, index, section, aidenLink) {
    var guideId = normalizeValue(guide && guide.id) || 'guide-' + index;
    var guideType = normalizeValue(guide && guide.type) || 'guide';
    var fields = (guide && guide.fields) || {};
    var language = normalizeValue(fields.language) || 'en';
    var videoId = resolveVideoId(fields.video);
    var labels = {
      aidenProfileLabel: normalizeValue(section.dataset.aidenProfileLabel) || 'Aiden Profile ->',
      overviewLabel: normalizeValue(section.dataset.overviewLabel) || 'Overview',
      grindLabel: normalizeValue(section.dataset.grindLabel) || 'Grind',
      recipeLabel: normalizeValue(section.dataset.recipeLabel) || 'Recipe',
      grindCalcLabel: normalizeValue(section.dataset.grindCalcLabel) || 'Grind Calculator ->',
      espressoLinePressureLabel: normalizeValue(section.dataset.espressoLinePressureLabel) || 'Line Pressure: 0-3.5s'
    };

    var guideBodyClass = 'guide-body';
    if (!videoId) guideBodyClass += ' textonly';
    if (index === 0) guideBodyClass += ' active';

    var videoHtml = '';
    if (videoId) {
      var embedId = 'wistia_id_' + guideType + '_' + language + '_' + section.id + '_' + index;
      videoHtml = [
        '<div class="guide-video" data-video-id="' + escapeHtml(videoId) + '">',
        '<div id="' + escapeHtml(embedId) + '" class="wistia_embed wistia_async_' + escapeHtml(videoId) + '" style="height:100%;width:100%;">&nbsp;</div>',
        '</div>'
      ].join('');
    }

    var topHtml = buildGuideTopHtml(guide, labels, aidenLink);

    var timerHtml = '';
    var showTimers = String(section.dataset.showBrewTimers) === 'true';
    if (showTimers && !shouldHideBrewTimer(guide)) {
      timerHtml = buildTimerHtml(guide);
    }

    return [
      '<div class="' + guideBodyClass + '" data-guide="' + escapeHtml(guideId) + '">',
      videoHtml,
      '<div class="guide-text"><div class="top">',
      topHtml,
      '</div></div>',
      '</div>',
      '<div class="brew-timer-container' + (index === 0 ? ' active' : '') + '" data-guide="' + escapeHtml(guideId) + '">' + timerHtml + '</div>'
    ].join('');
  }

  function maybeRenderFromKirby(section) {
    if (section.querySelector('.guide-body[data-guide]')) return;

    var candidates = resolveCandidates(section);
    var blocks = pickField(candidates.product, 'brew_guide_blocks');
    blocks = parseMaybeJson(blocks);
    if (!Array.isArray(blocks)) {
      if (window.Shopify && Shopify.designMode) {
        console.warn('[Brew Guides] Unable to resolve brew_guide_blocks from metafield candidates.', candidates.product);
      }
      return;
    }

    var aidenLink = normalizeValue(pickField(candidates.product, 'aiden_link'));

    var buttonContainer = section.querySelector('[data-brew-buttons]') || section.querySelector('.guide-header .right');
    var listContainer = section.querySelector('[data-brew-guide-list]');
    if (!buttonContainer || !listContainer) return;

    var buttonsHtml = blocks
      .map(function (guide, index) {
        var guideId = normalizeValue(guide && guide.id) || 'guide-' + index;
        var label = buildSelectorLabel(guide);
        return '<button type="button" data-guide="' + escapeHtml(guideId) + '" class="' + (index === 0 ? 'active' : '') + '">' + escapeHtml(label) + '</button>';
      })
      .join('');

    var guidesHtml = blocks
      .map(function (guide, index) {
        return buildGuideHtml(guide, index, section, aidenLink);
      })
      .join('');

    buttonContainer.innerHTML = buttonsHtml;
    listContainer.innerHTML = guidesHtml;

    var empty = section.querySelector('[data-brew-empty]');
    if (empty) empty.remove();

    if (window.Shopify && Shopify.designMode) {
      console.log('[Brew Guides] Rendered from metafield candidates:', blocks);
    }
  }

  function activateGuide(section, guideId) {
    if (!guideId) return;

    var buttons = section.querySelectorAll('.all-selector button[data-guide]');
    var bodies = section.querySelectorAll('.guide-body[data-guide]');
    var timers = section.querySelectorAll('.brew-timer-container[data-guide]');

    buttons.forEach(function (button) {
      button.classList.toggle('active', button.getAttribute('data-guide') === guideId);
    });

    bodies.forEach(function (body) {
      body.classList.toggle('active', body.getAttribute('data-guide') === guideId);
    });

    timers.forEach(function (timer) {
      timer.classList.toggle('active', timer.getAttribute('data-guide') === guideId);
    });
  }

  function initBrewTimerInstances(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var timers = scope.querySelectorAll('.brew-timer');
    if (!timers.length) return;

    timers.forEach(function (brewTimer) {
      if (brewTimer.dataset.btInitialized === 'true') return;
      brewTimer.dataset.btInitialized = 'true';

      var startText = brewTimer.querySelector('.start');
      var runningText = brewTimer.querySelector('.running');
      var runningAction = runningText ? runningText.querySelector('.step') : null;
      var runningTime = runningText ? runningText.querySelector('.step-detail .time') : null;
      var runningWeight = runningText ? runningText.querySelector('.step-detail .weight') : null;
      var fillingLine = brewTimer.querySelector('.timeline .filling-line');
      var preFillingLine = brewTimer.querySelector('.timeline .pre-line');
      var scrollContainer = brewTimer.querySelector('.timeline .events');
      var steps = brewTimer.querySelectorAll('.timeline .step');
      var startBtn = brewTimer.querySelector('button.start');
      var restartBtn = brewTimer.querySelector('button.restart');
      var pauseBtn = brewTimer.querySelector('button.pause');

      if (!startText || !runningText || !runningAction || !runningTime || !runningWeight || !fillingLine || !preFillingLine || !scrollContainer || !startBtn || !restartBtn || !pauseBtn || !steps.length) {
        return;
      }

      var isRunning = false;
      var timerInterval = null;
      var elapsedSeconds = 0;
      var currentWeight = 0;

      steps.forEach(function (step) {
        if (step.nextElementSibling) {
          step.dataset.nextStep = Number(step.nextElementSibling.dataset.time || 0) - Number(step.dataset.time || 0);
        }
      });

      startBtn.addEventListener('click', function () {
        startText.classList.add('hidden');
        runningText.classList.remove('hidden');
        preFillingLine.classList.add('active');
        updateDisplay();
        if (!isRunning) start();
      });

      restartBtn.addEventListener('click', function () {
        startText.classList.remove('hidden');
        runningText.classList.add('hidden');
        clearInterval(timerInterval);
        isRunning = false;
        elapsedSeconds = 0;
        currentWeight = 0;
        updateDisplay();
        steps.forEach(function (step) {
          step.classList.remove('active');
        });
        scrollContainer.scrollLeft = 0;
        fillingLine.style.transform = 'scaleX(0)';
        preFillingLine.classList.remove('active');
        pauseBtn.textContent = 'Pause timer';
      });

      pauseBtn.addEventListener('click', function () {
        if (isRunning) {
          clearInterval(timerInterval);
          isRunning = false;
          pauseBtn.textContent = 'Resume timer';
        } else {
          start();
          pauseBtn.textContent = 'Pause timer';
        }
      });

      function start() {
        isRunning = true;
        timerInterval = setInterval(function () {
          elapsedSeconds += 0.01;
          updateDisplay();
        }, 10);
      }

      function updateDisplay() {
        var floored = Math.floor(elapsedSeconds);
        var minutes = Math.floor((floored % 3600) / 60);
        var seconds = floored % 60;
        runningTime.textContent = minutes.toString().padStart(1, '0') + ':' + seconds.toString().padStart(2, '0');

        var activeSteps = 0;
        var stepProgress = 0;

        steps.forEach(function (step, index) {
          var stepStart = parseInt(step.dataset.time, 10) || 0;
          var nextStepDuration = parseInt(step.dataset.nextStep, 10) || 0;
          var stepWeight = parseInt(step.dataset.weight, 10) || 0;
          var flowRate = parseFloat(step.dataset.flowRate) || 10;
          var flowPerTick = flowRate / 100;

          if (elapsedSeconds >= stepStart) {
            if (!step.classList.contains('active')) {
              scrollContainer.scrollLeft = step.offsetLeft;
              step.classList.add('active');
            }
            runningAction.textContent = step.dataset.action;
            activeSteps = index + 1;
          }

          if (elapsedSeconds >= stepStart && nextStepDuration > 0 && elapsedSeconds < stepStart + nextStepDuration) {
            stepProgress = (elapsedSeconds - stepStart) / nextStepDuration;
            currentWeight = Math.min(stepWeight, currentWeight + flowPerTick);
          }
        });

        runningWeight.textContent = Math.floor(currentWeight);

        var totalSteps = steps.length;
        var denominator = Math.max(totalSteps - 1, 1);
        var progress = (activeSteps - 1 + stepProgress) / denominator;
        if (!Number.isFinite(progress) || progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        fillingLine.style.transform = 'scaleX(' + progress + ')';
      }
    });
  }

  function bindButtons(section) {
    var buttons = Array.prototype.slice.call(section.querySelectorAll('.all-selector button[data-guide]'));

    buttons.forEach(function (button) {
      if (button.dataset.brewBound === 'true') return;

      button.addEventListener('click', function () {
        activateGuide(section, button.getAttribute('data-guide'));
      });

      button.dataset.brewBound = 'true';
    });

    if (buttons.length) {
      var initial = section.querySelector('.all-selector button.active[data-guide]');
      var initialId = initial ? initial.getAttribute('data-guide') : buttons[0].getAttribute('data-guide');
      activateGuide(section, initialId);
    }
  }

  function initSection(section) {
    if (!section || section.dataset.brewGuidesInitialized === 'true') return;

    maybeRenderFromKirby(section);
    bindButtons(section);
    initBrewTimerInstances(section);

    section.dataset.brewGuidesInitialized = 'true';
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-brew-guides]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
